<!-- Hero Start -->
<section class="main-slider" id="home">

 <ngb-carousel class="slides hero-carousel" [showNavigationArrows]="showNavigationArrows"
  [showNavigationIndicators]="showNavigationIndicators" [interval]="6000" [pauseOnHover]="false">

  <!-- Slide 1: Laundry -->
  <ng-template ngbSlide>
    <div class="hero-slide d-flex align-items-center">
      <div class="slide-bg" style="background-image: url('assets/images/blog/laundry-bg.png');"></div>
      <div class="bg-overlay"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="title-heading text-center">
              <h2 class="hero-title text-white mb-3">{{'Premium Laundry Services' | translate}}</h2>
              <p class="hero-desc para-desc mx-auto text-white-50 mb-0">
                {{'From pickup to delivery, we handle your laundry with care and precision — clean, fresh, and folded to perfection, right on your schedule.' | translate}}
              </p>
              <div class="hero-cta mt-4">
                <a routerLink="/contact" class="btn-glass">{{'Contact Us' | translate}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Slide 2: Car Wash -->
  <ng-template ngbSlide>
    <div class="hero-slide d-flex align-items-center">
      <div class="slide-bg" style="background-image: url('assets/images/blog/carwash-bg2.jpeg');"></div>
      <div class="bg-overlay"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="title-heading text-center">
              <h2 class="hero-title text-white mb-3">{{'Car Wash at Your Doorstep' | translate}}</h2>
              <p class="hero-desc para-desc mx-auto text-white-50 mb-0">
                {{'Professional exterior and interior car cleaning wherever you are — save time with our mobile car wash experts, no need to leave home or work.' | translate}}
              </p>
              <div class="hero-cta mt-4">
                  <a routerLink="/contact" class="btn-glass">{{'Contact Us' | translate}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Slide 3: Home Cleaning -->
  <ng-template ngbSlide>
    <div class="hero-slide d-flex align-items-center">
      <div class="slide-bg" style="background-image: url('assets/images/blog/homeclean-bg.png');"></div>
      <div class="bg-overlay"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="title-heading text-center">
              <h2 class="hero-title text-white mb-3">{{'Spotless Homes, Every Time' | translate}}</h2>
              <p class="hero-desc para-desc mx-auto text-white-50 mb-0">
                {{'Trusted home cleaning teams equipped with eco-friendly products, delivering a spotless, healthy living space tailored to your needs.' | translate}}
              </p>
              <div class="hero-cta mt-4">
                  <a routerLink="/contact" class="btn-glass">{{'Contact Us' | translate}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

</ngb-carousel>

 <!-- <ngb-carousel class="slides" [showNavigationArrows]="showNavigationArrows"
  [showNavigationIndicators]="showNavigationIndicators">

  <ng-template ngbSlide >
    <div  class="bg-home-75vh d-flex align-items-center" 
      style="height: 100vh;background: url('assets/images/blog/laundry-bg.webp') center center; background-size: cover;">
      <div class="bg-overlay rounded-md"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="title-heading text-center">
              <h2 class="text-white title-dark mb-3">{{'Premium Laundry Services' | translate}}</h2>
              <p class="para-desc mx-auto text-white-50 mb-0">
                {{'From pickup to delivery, we handle your laundry with care and precision — clean, fresh, and folded to perfection, right on your schedule.' | translate}}
              </p>
              <div class="mt-4">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template ngbSlide>
    <div class="bg-home-75vh d-flex align-items-center" 
      style="background: url('assets/images/blog/carwash-bg2.jpeg') center center; background-size: cover;">
      <div class="bg-overlay rounded-md"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="title-heading text-center">
              <h2 class="text-white title-dark mb-3">{{'Car Wash at Your Doorstep' | translate}}</h2>
              <p class="para-desc mx-auto text-white-50 mb-0">
                {{'Professional exterior and interior car cleaning wherever you are — save time with our mobile car wash experts, no need to leave home or work.' | translate}}
              </p>
              <div class="mt-4">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template ngbSlide>
    <div class="bg-home-75vh d-flex align-items-center" 
      style="background: url('assets/images/blog/homeclean-bg.webp') center center; background-size: cover;">
      <div class="bg-overlay rounded-md"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="title-heading text-center">
              <h2 class="text-white title-dark mb-3">{{'Spotless Homes, Every Time' | translate}}</h2>
              <p class="para-desc mx-auto text-white-50 mb-0">
                {{'Trusted home cleaning teams equipped with eco-friendly products, delivering a spotless, healthy living space tailored to your needs.' | translate}}
              </p>
              <div class="mt-4">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

</ngb-carousel> -->


</section>

  <div class="container mt-4 mt-lg-0">
  

    <section class="section" style="padding: 0 0;">
   <div class="container mt-100 mt-60">
    <div class="row align-items-center mb-4 pb-4">
      <div class="col-md-12">
        <div class="section-title text-md-center">
          <h4 class="mb-4">{{'Our latest news' | translate}}</h4>
          <!-- <p class="text-muted mb-4 para-desc">{{'Our latest news' | translate}}</p> -->
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
    <app-blog [blogData]="blogs"></app-blog>
    <div class="col-12 mt-4 pt-2">
      <div class="text-center">
        <a routerLink="/blogs" class="btn btn-primary">{{'See More' | translate}} 
          <i-feather name="arrow-right" class="fea icon-sm" *ngIf="currentLang != 'ar'"></i-feather>
          <i-feather name="arrow-left" class="fea icon-sm" *ngIf="currentLang == 'ar'"></i-feather>
        </a>
      </div>
    </div>
    <!--end row-->
  </div>

<div class="container mt-100 mt-60">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="section-title text-center mb-4 pb-2">
        <h6 class="text-primary">{{'Work Process' | translate}}</h6>
        <h4 class="title mb-4">{{'How do we work?' | translate}}</h4>
        <p class="text-muted para-desc mx-auto mb-0">
          {{'From pickup to delivery, ' | translate}}<span class="text-primary fw-bold">{{'Easy Wash' | translate}}</span>
          {{' takes care of every step so you get clean, fresh laundry without any hassle.' | translate}}
        </p>
      </div>
    </div><!--end col-->
  </div><!--end row-->

  <div class="row">
    <!-- Step 1: Pickup -->
    <div class="col-md-4 mt-4 pt-2">
        <div class="card features feature-primary feature-clean work-process bg-transparent  border-0 text-center"
      >
        <div class="icons text-center mx-auto">
          <i class="uil uil-box d-block rounded h3 mb-0"></i>
        </div>
        <div class="card-body">
          <h5 class="text-dark">{{'Pickup' | translate}}</h5>
          <p class="text-muted mb-0">
            {{'Schedule a pickup time that suits you, and our team collects your laundry directly from your doorstep.' | translate}}
          </p>
        </div>
      </div>
    </div><!--end col-->

    <!-- Step 2: Wash -->
    <div class="col-md-4 mt-md-5 pt-md-3 mt-4 pt-2">
  <div class="card features feature-primary feature-clean work-process bg-transparent  border-0 text-center">
        <div class="icons text-center mx-auto">
          <i class="uil uil-water-glass d-block rounded h3 mb-0"></i>
        </div>
        <div class="card-body">
          <h5 class="text-dark">{{'Wash' | translate}}</h5>
          <p class="text-muted mb-0">
            {{'Your clothes are professionally cleaned using high-quality equipment and safe, effective detergents.' | translate}}
          </p>
        </div>
      </div>
    </div><!--end col-->

    <!-- Step 3: Delivery -->
    <div class="col-md-4 mt-md-5 pt-md-5 mt-4 pt-2">
        <div class="card features feature-primary feature-clean work-process bg-transparent  border-0 text-center"
      >
        <div class="icons text-center mx-auto">
          <i class="uil uil-truck d-block rounded h3 mb-0"></i>
        </div>
        <div class="card-body">
          <h5 class="text-dark">{{'Delivery' | translate}}</h5>
          <p class="text-muted mb-0">
            {{'Fresh, clean, and neatly folded — your laundry is delivered back to you right on schedule.' | translate}}
          </p>
        </div>
      </div>
    </div><!--end col-->
  </div><!--end row-->
</div>

<!--end container-->
      <div class="container mt-100 mt-60" *ngIf="temamembers && temamembers.length>0">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="section-title text-center mb-4 pb-2">
                    <h4 class="title mb-4">{{'Board members' | translate}}</h4>
                    <p class="text-muted mx-auto para-desc mb-0">{{'People we are proud of' | translate}}</p>
                </div>
            </div><!--end col-->
        </div><!--end row-->
        <div class="row" *ngIf="temamembers && temamembers.length > 0">
        <team-carousel [temamembers]="temamembers" [currentLang]="currentLang"></team-carousel>

            <!-- <div class="col-lg-3 col-md-6 mt-4 pt-2" *ngFor="let item of temamembers">
                <div class="card team team-primary text-center border-0">
                    <div class="position-relative">
                        <img src="{{item.ImageUrl}}"
                            class="img-fluid avatar avatar-ex-large rounded-circle shadow" alt="">
                        <ul class="list-unstyled mb-0 team-icon">
                            <li class="list-inline-item ms-1"><a href="{{item.Facebook}}"
                                    class="btn btn-primary btn-pills btn-sm btn-icon"><i-feather name="facebook"
                                        class="icons"></i-feather></a></li>
                            <li class="list-inline-item ms-1"><a href="{{item.Instagram}}"
                                    class="btn btn-primary btn-pills btn-sm btn-icon"><i-feather name="instagram"
                                        class="icons"></i-feather></a></li>
                            <li class="list-inline-item ms-1"><a href="{{item.Twitter}}"
                                    class="btn btn-primary btn-pills btn-sm btn-icon"><i-feather name="twitter"
                                        class="icons"></i-feather></a></li>
                            <li class="list-inline-item ms-1"><a href="{{item.LinkedIn}}"
                                    class="btn btn-primary btn-pills btn-sm btn-icon"><i-feather name="linkedin"
                                        class="icons"></i-feather></a></li>
                        </ul>
                    </div>
                    <div class="card-body py-3 px-0 content">
                        <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">{{ currentLang != 'ar' ? item.NameEn : item.NameAr }}  </a></h5>
                        <small class="designation text-muted">{{ currentLang != 'ar' ? item.JobTitleEn : item.JobTitleAr }}</small>
                    </div>
                </div>
            </div> -->

          
        </div><!--end row-->
    </div><!--end container-->
 <div class="container-fluid mt-100 mt-60">
        <div class="bg-cta shadow rounded card overflow-hidden"
            style="background: url('https://wpress.alaghr.sa/wp-content/uploads/2026/04/%D8%B4%D8%B3%D8%A8%D9%8A%D8%B4%D9%8A%D8%A8%D8%B4-3-scaled.png') center center;" id="cta">
            <div class="bg-overlay"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 text-center">
                        <div class="section-title">
                            <h4 class="title title-dark text-white mb-4"></h4>
                            <p class="text-white-50 para-dark para-desc mx-auto"></p>
                            <a href="http://youtube.com/shorts/qZSZVd_4C8Y?si=asBg6C1FLM2s9Nu7" class="play-btn mt-4 video-play-icon">
                                <i-feather name="play" class="fea icon-ex-md text-white title-dark"></i-feather>
                            </a>
                        </div>
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end container-->
        </div>
    </div><!--end container-->
   
</section>
  </div>
   
<section class="section" style="padding: 0 0;">
  <!-- <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="features-absolute blog-search">
          <div class="row justify-content-center">
            <div class="col-md-10">
              <div class="text-center subcribe-form">
                <form style="max-width: 800px;">
                  <input type="text" id="course" name="name" class="border shadow rounded-pill bg-white-color"
                    placeholder="{{'Search'|translate}}">
                  <button type="submit" class="btn btn-pills btn-primary">{{'Search'|translate}}</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->


<div class="container mt-100 mt-60">
  <div class="row align-items-center mb-4 pb-4">
    <div class="col-md-8">
      <div class="section-title text-md-left">
        <h4 class="mb-4">{{'Same of our projects' | translate}}</h4>
        <p class="text-muted mb-0 para-desc">{{'Discover our latest projects and innovations' | translate}}</p>
      </div>
    </div>
    <!--end col-->

    <div class="col-md-4 mt-4 mt-sm-0">
      <div class="text-center text-md-end">
        <a routerLink="/projects" class="btn btn-soft-primary">{{'See More' | translate}}
          <i-feather name="arrow-right" class="icons" *ngIf="currentLang != 'ar'"></i-feather>
          <i-feather name="arrow-left" class="icons" *ngIf="currentLang == 'ar'"></i-feather>
        </a>
      </div>
    </div>
    <!--end col-->
  </div>
  <!--end row-->

  <section>
    <div class="container mt-5 mt-sm-0">

      <div class="row">
        <div class="col-md-6 col-lg-4 mt-4 pt-2" *ngFor="let project of ourprojects; let i = index">

          <div class="showcase-card animate-card" [style.animation-delay]="(i * 0.12) + 's'">

            <a routerLink="/project-details/{{project.Id}}" class="showcase-link">

              <div class="showcase-media">
                <img *ngIf="project && project.Images && project.Images[0]?.ImageUrl"
                     [src]="project.Images[0]?.ImageUrl"
                     class="showcase-img"
                     alt="">
                <div class="showcase-gradient"></div>

                <span class="showcase-view-btn">
                  {{'View Project' | translate}}
                  <i-feather name="arrow-up-right" class="icons"></i-feather>
                </span>
              </div>

              <div class="showcase-content">
                <span class="showcase-tag">{{'Project' | translate}}</span>
                <h5 class="showcase-title">
                  {{currentLang === 'ar' ? project.TitleAr : project.TitleEn}}
                </h5>
                <p class="showcase-subtitle">
                  {{currentLang === 'ar' ? project.SubTitleAr : project.SubTitleEn}}
                </p>
              </div>
            </a>

            <button type="button" class="showcase-bookmark" (click)="$event.stopPropagation()">
              <i class="uil uil-bookmark align-middle"></i>
            </button>

          </div>

        </div>

      </div>
      <!--end row-->
    </div>
    <!--end container-->
  </section>
</div>

<div class="container-fluid mt-100 mt-60">
  <div class="rounded-md shadow-md py-5 position-relative how-it-works-section"
    style="background: url('assets/images/blog/laundry-bg.png') center center; background-size: cover;">
    <div class="bg-overlay rounded-md" style="z-index: 0;"></div>
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="section-title text-center mb-4 pb-2">
            <h2 class="fw-bold text-white title-dark mb-3">{{'How Easy Wash Works' | translate}}</h2>
            <p class="para-desc mx-auto text-white-50 mb-0">
              {{'Three simple steps to fresh, clean clothes — without leaving your home.' | translate}}
            </p>
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->

      <div class="row process-steps-row">

        <!-- خط التايم لاين بين الخطوات (يظهر على شاشات كبيرة فقط) -->
        <div class="process-connector d-none d-lg-block"></div>

        <!-- Step 1: Pickup -->
        <div class="col-lg-4 col-md-6 mt-4 pt-2">
          <div class="card border-0 text-center process-box bg-white rounded shadow p-4 h-100 animate-step">
            <span class="step-number">01</span>
            <div class="icons text-center mx-auto">
              <div class="icon-box bg-soft-primary rounded-circle d-flex align-items-center justify-content-center mx-auto">
                <i-feather name="package" class="fea icon-md text-primary"></i-feather>
              </div>
            </div>
            <div class="content mt-4">
              <h5 class="title">{{'1. Pickup' | translate}}</h5>
              <p class="text-muted mb-0 ">
                {{'Schedule a pickup time that suits you, and our team will collect your laundry directly from your doorstep.' | translate}}
              </p>
            </div>
          </div>
        </div>
        <!--end col-->

        <!-- Step 2: Wash -->
        <div class="col-lg-4 col-md-6 mt-4 pt-2">
          <div class="card border-0 text-center process-box bg-white rounded shadow p-4 h-100 animate-step">
            <span class="step-number">02</span>
            <div class="icons text-center mx-auto">
              <div class="icon-box bg-soft-primary rounded-circle d-flex align-items-center justify-content-center mx-auto">
                <i-feather name="droplet" class="fea icon-md text-primary"></i-feather>
              </div>
            </div>
            <div class="content mt-4">
              <h5 class="title">{{'2. Wash' | translate}}</h5>
              <p class="text-muted mb-0 ">
                {{'Your clothes are professionally cleaned using high-quality equipment and safe, effective detergents.' | translate}}
              </p>
            </div>
          </div>
        </div>
        <!--end col-->

        <!-- Step 3: Delivery -->
        <div class="col-lg-4 col-md-6 mt-4 pt-2">
          <div class="card border-0 text-center process-box bg-white rounded shadow p-4 h-100 animate-step">
            <span class="step-number">03</span>
            <div class="icons text-center mx-auto">
              <div class="icon-box bg-soft-primary rounded-circle d-flex align-items-center justify-content-center mx-auto">
                <i-feather name="truck" class="fea icon-md text-primary"></i-feather>
              </div>
            </div>
            <div class="content mt-4">
              <h5 class="title">{{'3. Delivery' | translate}}</h5>
              <p class="text-muted mb-0 ">
                {{'Fresh, clean, and neatly folded — your laundry is delivered back to you right on schedule.' | translate}}
              </p>
            </div>
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->
    </div>
    <!--end container-->
  </div>
  <!--end slide-->
</div>
  <!--end container-->
  <!-- Cta End -->
  <section class="section" style="padding:30px 0">
    <div class="container">
 <div class="row align-items-center">
              <div class="row align-items-center mb-4 pb-2">
      <div class="col-md-12">
        <div class="section-title text-md-center">
          <h3 class="mb-4">{{'Some of our services' | translate}}</h3>
    
        </div>
      </div>

      <!-- <div class="col-md-4 mt-4 mt-sm-0">
        <div class="text-center text-md-end">
          <a href="javascript:void(0)" class="btn btn-soft-primary">{{'See More' | translate}}
            <i-feather name="arrow-right" class="fea icon-sm"></i-feather>
          </a>
        </div>
      </div> -->
    </div>
            <div class="col-lg-4 col-md-6" *ngFor="let service of ourservices">
                <div
                    class="card border-0 features feature-primary feature-clean course-feature p-4 overflow-hidden shadow">
                      <!-- <div class="icons text-center">
                        <i class="uil uil-heart d-block rounded h3 mb-0"></i>
                    </div> -->
                    <div class="icons text-center">
                       <img [src]="service.ImageUrl" [alt]="service.TitleEn" width="100px" class="img-fluid">
                    </div>
                    <div class="card-body p-0 mt-4">
                        <a routerLink="/service-detail/{{service.Id}}" class="title h5 text-dark">{{ currentLang != 'ar' ? service.TitleEn : service.TitleAr }}</a>
                        <p class="text-muted mt-2">{{ currentLang != 'ar' ? service.DescriptionEn : service.DescriptionAr }}
                        </p>
                        <a routerLink="/service-detail/{{service.Id}}" class="read-more">{{'Read More' | translate}} 
                          <i class="uil uil-angle-right-b" *ngIf="currentLang == 'en'"></i>
                          
                          <i class="uil uil-angle-left-b" *ngIf="currentLang == 'ar'"></i>
                        </a>
                        <i class="uil uil-airplay full-img"></i>
                    </div>
                </div>
            </div><!--end col-->

        </div>
        </div><!--end row-->
  <!--end container-->
  </section>
</section>

<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->